import React from "react";
import { EarningsCalendarWidget } from "@/components/EarningsCalendarWidget";
import { useRouter } from "next/router";
import Head from "next/head";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSideProps } from "next";

const EmbedEarningsPage = () => {
  const router = useRouter();
  const { theme, width } = router.query;

  return (
    <div className="fixed inset-0 bg-transparent flex justify-center items-stretch overflow-hidden">
      <Head>
        <title>Earnings Calendar Widget</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
        <style>{`
          body {
            background: transparent !important;
            margin: 0;
            padding: 0;
            overflow-x: hidden;
          }
          /* Custom scrollbar for small embedded view */
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.02);
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 10px;
          }
        `}</style>
      </Head>
      <EarningsCalendarWidget 
        width={width ? String(width) : "100%"} 
        theme={(theme as any) || "dark"}
      />
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "en", ["broker-page", 
        "common-page",
        "layout-page",
      ])),
    },
  };
};

export default EmbedEarningsPage;
